import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ModuleTitleComponent } from "@shared/components/module-title/module-title.component";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from "@angular/router";
import { CommonModule } from "@angular/common";
import { filter } from "rxjs";
import { UserRequestsComponent } from "../user-managment/user-requests/user-requests.component";

@Component({
  selector: "app-configurations",
  imports: [
    ModuleTitleComponent,
    PrimeNGSharedModule,
    RouterOutlet,
    CommonModule,
  ],
  templateUrl: "./configurations.component.html",
  styleUrl: "./configurations.component.scss",
})
export class ConfigurationsComponent implements OnInit {
  activeTab: "country" | "type-of-change" | "product-family" = "country";
  requestTotalRecords: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateActiveTabFromUrl();
      });

    this.updateActiveTabFromUrl();
  }

  private updateActiveTabFromUrl(): void {
    const urlSegments = this.router.url.split("/");
    const lastSegment = urlSegments[urlSegments.length - 1];

    if (lastSegment === "country") {
      this.activeTab = "country";
    } else if (lastSegment === "type-of-change") {
      this.activeTab = "type-of-change";
    } else if (lastSegment === "product-family") {
      this.activeTab = "product-family";
    } else {
      this.activeTab = "country";
      if (this.router.url === "/configuration") {
        this.router.navigate(["./country"], {
          relativeTo: this.activatedRoute,
          replaceUrl: true,
        });
      }
    }
    this.cdr.detectChanges();
  }

  navigateToTab(
    tabName: "country" | "type-of-change" | "product-family"
  ): void {
    this.router.navigate([`./${tabName}`], { relativeTo: this.activatedRoute });
  }
}
